<template>
  <div class="specifications">
    <div
      @click="$emit('showAll')"
      class="header"
    >
      <div class="title">
        Product Specifications
      </div>
      <Icon name="arrow-right-l-2" />
    </div>
    <div class="body">
      <div
        v-for="(item, index) in list.slice(0, 6)"
        :key="index"
        class="item"
      >
        <div class="text-1">
          {{ item.attributeNameTrans }}
        </div>
        <div class="text-2">
          {{ item.valueTrans }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Icon } from '@/components/Icon'

defineEmits(['showAll'])

const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const specifications = ref([])

const formatSpecifications = (arr) => {
  const result = {}

  // 遍历输入数组
  arr.forEach((item) => {
    const {
      attributeId,
      attributeName,
      attributeNameTrans,
      value,
      valueTrans
    } = item

    if (!result[attributeId]) {
      // 如果 attributeId 不在 result 对象中，初始化
      result[attributeId] = {
        attributeId,
        attributeName,
        attributeNameTrans,
        value,
        valueTrans
      }
    } else {
      // 如果 attributeId 已存在，拼接 valueTrans
      result[attributeId].valueTrans += `, ${valueTrans}`
    }
  })

  // 将结果对象转换为数组
  specifications.value = Object.values(result)
}

onMounted(() => {
  formatSpecifications(props.list)
})

</script>

<style lang='less' scoped>
 .specifications {
  padding: 12px;
  background-color: white;
  margin-top: 8px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #232323;
    font-size: 14px;
    font-family: mon-700;
  }
  .body {
    width: 100%;
    margin-top: 12px;
    border-radius: 8px;
    background-color: #f8f8f8;
    padding: 12px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 12px;
    .item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 2px;
      min-width: 0;
      padding-right: 4px;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        height: 24px;
        border-right: 1px dashed #dfdfdf;
      }

      &:nth-child(3n)::after {
        display: none;
      }

      .text-1, .text-2 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
      }
      .text-1 {
        color: #232323;
        font-size: 12px;
        font-family: mon-600;
        line-height: 16px;
      }
      .text-2 {
        color: #6E717A;
        font-size: 10px;
        font-family: mon-500;
        line-height: 14px;
      }
    }
  }
}
</style>
